<template>
    <b-modal ref="modal" centered no-close-on-backdrop no-close-on-esc hide-header hide-footer>
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{$t('JOBFORM')}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="close()" class="close"><img src="../../../assets/img/icon-close.svg"></button>
        </div>
        <div class="d-block mt-2 modal-content-inside">
          <div role="group" class="b-form-group form-group" v-if="formData != null">
            <div class="form-row">
                <div class="col-sm-12">
                <b-form-fieldset v-bind:label="$t('DECLINE')">
                    <inputvalidation :formerror="formError" name="decline">
                        <b-form-textarea type="text" v-model="formData.decline"></b-form-textarea>
                    </inputvalidation>
                </b-form-fieldset>
                </div>
            </div>
          </div>

          <div class="text-center mt-lg">
              <b-btn class="mr-2 btn-bis btn-cancel" @click="close()">{{$t('CANCEL')}}</b-btn>
              <b-btn class="btn-bis btn-primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
          </div>

          </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';    
import Api from '@/api/job/Job.js';


export default
{
    name: 'DeclineForm',
    props: ['value'],
    data()
    {
        const me = this;

        return {
            formError: {},
            formData: null,
        };
    },
    methods:
    {
        async submitData(item)
        {
            const me = this;
            try
            {
                if (typeof item.jobId !== 'undefined')
                {
                    item.id = item.jobId;
                    delete (item.jobId);
                }

                if (item.decline == null || item.decline == '')
                {
                    const error =  {
                        "error": true,
                        "code": "reason_not_entered",
                        "notice": "REASONNOTENTERED",
                        "params": {
                            "field": "decline"
                        }
                    }
                    me.formError = {errors: [error]};
                    throw (error);
                }

                const data = await Api.save(item);
                me.$notify.notice(data);

                if (data.error)
                {
                    me.formError = data;
                }
                else
                {
                    me.close();
                }
            }
            catch (e)
            {
                console.log(e);
                me.$notify.notice(e);
            }
        },
        close()
        {
            const me = this;
            me.formData = null;
            me.formError = {};
            me.$emit('close');
        },
    },
    watch:
    {
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
    },
};
</script>
